import React from 'react';
import { Lessons } from '../../Lessons';
import { LessonView } from './LessonView';
import { LessonColumn } from './LessonColumn';
import "./Lesson.scss";

const columns = [
  {lessonFirst: 0,  lessonLast: 6},
  {lessonFirst: 7,  lessonLast: 12},
  {lessonFirst: 13, lessonLast: 17},
];

export class LessonPage extends React.Component {
  constructor(props) {
    super(props);
    console.log("LessonPage constructed:", props);
    this.onLessonSelected = this.onLessonSelected.bind(this);
  }

  onLessonSelected(lessonId) {
    this.props.onLessonSelected(lessonId);
  }

  render() {
    return (
      <div className="lessonContainerContainer">
        <div className="lessonContainer">
          {
            columns.map((column) => <LessonColumn key={`lesson-column-${column.lessonFirst}`}>{Lessons.lessons.slice(column.lessonFirst, column.lessonLast + 1).map((lesson) => <LessonView key={`lesson-view-${lesson.name}`} lesson={lesson} onLessonSelected={this.onLessonSelected} /> )}</LessonColumn>)
          }
        </div>
      </div>
    );
  }
}
